import { useMemo } from 'react';
/**
 * Calculate earnings forecast by multiplying daily earnings by period
 *
 * It uses the daily_earnings already calculated by the portfolio,
 * which includes: (supply interest + rewards) - (borrow interest)
 */
export function useForecast(portfolioData, forecastPeriod = '7D') {
    var _a;
    const summary = useMemo(() => {
        var _a;
        // Return null if we don't have portfolio data yet
        if (!((_a = portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.lowFreq) === null || _a === void 0 ? void 0 : _a.daily_earnings)) {
            return null;
        }
        // Get daily earnings (already in USD from portfolio)
        const dailyEarnings = parseFloat(portfolioData.lowFreq.daily_earnings);
        // Handle invalid/NaN values
        if (isNaN(dailyEarnings)) {
            return null;
        }
        // Get number of days for this period
        const periodDays = getPeriodDays(forecastPeriod);
        // Calculate total earnings: daily * number of days
        const totalEarnings = dailyEarnings * periodDays;
        return {
            totalEarnings,
            dailyEarnings,
            period: forecastPeriod,
            periodDays,
        };
    }, [(_a = portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.lowFreq) === null || _a === void 0 ? void 0 : _a.daily_earnings, forecastPeriod]);
    return {
        summary,
        isLoading: !(portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.lowFreq),
        hasData: !!summary,
    };
}
/**
 * Convert period to number of days
 */
function getPeriodDays(period) {
    switch (period) {
        case '1D':
            return 1;
        case '7D':
            return 7;
        case '30D':
            return 30;
        case '1Y':
            return 365;
    }
}
